<div [ngSwitch]="linkCheck" oxAdobeDataNotifications>

<div *ngSwitchCase="'banner'">
<div *ngIf="bannerToggle">
  <div class="col-md-12 col-xs-12 bg-dark py-2 display-flex align-self-stretch align-items-sm-start justify-content-center">
    <div class="row">
      <div
        class="gb-body2 gb-align-center">
        <p class="mb-0 white-text">{{'my_plans_offer_banner_text' | translate}} <a
            class="gb-body2-link white-text" tabindex="0" (keyup.enter)="goToShop()" attr.aria-label="{{'my_plans_offer_banner_link' | translate}}" (click)="goToShop()">{{'my_plans_offer_banner_link' | translate}}</a></p>
      </div>
    </div>
</div>
</div>
</div>


<div *ngSwitchCase="'button'">
  <div class="gb-align-center pt-3">
    <div class="mx-auto" style="width:287px;">
       <a *ngIf="bannerToggle" (click)="goToShop()" class="gb-primary-button" attr.aria-label="{{'my_plans_offer_banner_link' | translate}}" tabindex="0" (keyup.enter)="goToShop()">{{'my_plans_offer_banner_link' | translate}}</a>
    </div>
</div>
</div>
</div>
